import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import SpecialSlots from "../../SiteAdmin/Slot/SpecialSlots";
import Slot from "../../SiteAdmin/Slot/Slot";
import { URL } from "../../../Services/Constant";
import { get } from "../../../Services/ApiHandler";
import moment from "moment/moment";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const GroupAlertDays = () => {
  const [activeTab, setActiveTab] = useState("week");
  const [days, setDays] = useState([...days_arr]);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const userData = JSON.parse(localStorage.getItem("user_details"));

  const [groupEscalations, setGroupEscalations] = useState([]);

  const getList = () => {
    get(URL.GROUP_USERS + userData?.knf_company_site_id)
      .then((res) => {
        if (res?.data?.special_dates?.length > 0) {
          special_dates(res);
        }

        if (res?.data?.special_day?.length > 0) {
          weekDays(res);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const special_dates = (res) => {
    let temp = [];
    let data = [...res?.data?.special_dates];
    data?.map((item, ind) => {
      let obj = {
        ...item,
        toggle: item?.start_time && item?.end_time ? true : false,
        date: item?.for_date,
        for_date: moment(item?.for_date).format("DD-MM-YYYY"),
        start_time: item?.start_time
          ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
          : "",
        end_time: item?.end_time
          ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
          : "",
      };
      temp.push(obj);
    });
    setDates(temp);
    setSelectedDate(temp?.[0]?.id);
    setDates(temp);
  };

  const weekDays = (res) => {
    let temp = [...days_arr];
    let data = [...res?.data?.special_day];
    let day_type = [1, 2, 3, 4, 5, 6, 7];
    data?.map((item, ind) => {
      if (day_type?.includes(item?.type)) {
        let indexToReplace = day_type.findIndex((i) => i === item?.type);
        temp[indexToReplace] = {
          ...temp[indexToReplace],
          toggle: true,
          start_time: item?.start_time
            ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
            : "",
          end_time: item?.end_time
            ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
            : "",
        };
      }
    });
    setDays(temp);
  };

  useEffect(() => {
    getList();
  }, []);

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleTab = (days) => {
    setActiveTab(days);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Days"} hide={true} />
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && (
          <Slot
            superAdmin={true}
            days={days}
            setDays={setDays}
            noEditable={true}
          />
        )}
        {activeTab == "special" && (
          <SpecialSlots
            superAdmin={true}
            dates={dates}
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setDates={setDates}
          />
        )}
      </div>
    </div>
  );
};

export default GroupAlertDays;
